import api from "./api";

// Login — returns { token, user: { id, full_name, role, ... } }
export const loginApi = (phone, password) =>
  api.post("/auth/login", { phone, password });

// Signup — returns { token, user }
export const signupApi = (data) =>
  api.post("/auth/signup", data);

// Get currently logged-in user profile
export const meApi = () =>
  api.get("/auth/me");

// Change password
export const changePasswordApi = (old_password, new_password) =>
  api.post("/auth/change-password", { old_password, new_password });